module.exports = __webpack_public_path__ + "assets/img/sfj.a2ba6826.png";